import { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import styles from './customerToTarget.module.scss'
import Paper from '../../../components/Paper';
import LogicalChooser from '../../../components/LogicalChooser';
import { nextStepValidtor, writeSummary } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { makeCustomerSegmentTree } from '../helpers';
import { getCustomerCount, setTargetCustomerCount, isValidForNext, resetStep2MissingValue, setStep3MissingValue } from '../createCampaignReducer';
import { showNudge, SEVEARITY_CONTS } from '../../../components/Nudge/nudgeReducer';
import { MISSING_VALUE_MESSAGE } from '../../../utils/constants';


const operatorSubAll = "(Include Business Ids that meet ALL of these conditions)"
const operatorSubAnyone = "(Include Business Ids that meet ANY ONE of these conditions)"
const optionHeader = "Customer Attributes"

const CustomerToTarget = ({ data, state, setters, nextStepValid, nextStepState, nextStepSetters }) => {
  const dispatch = useDispatch();
  const customerSegment = useSelector(store => store.createCampaign.attributeData.data);
  const customerCount = useSelector(store => store.createCampaign.targetCustomerCount);
  const customerCountLoading = useSelector(store => store.createCampaign.customerCountLoading);
  const customerCountError = useSelector(store => store.createCampaign.customerCountError);
  const {isRemovedValue, message} = useSelector(store => store.createCampaign.step2MissingValue)
  const step3Data = useSelector(store => store.createCampaign.productSegment.data)
  let excludeSub = operatorSubAll
  let includeSub = operatorSubAll
  if (state.include.operator === "OR") {
    includeSub = operatorSubAnyone
  }
  if (state.exclude.operator === "OR") {
    excludeSub = operatorSubAnyone
  }
  const fetchCustomerCount = () => {
    const customerSegmentQueryTree = makeCustomerSegmentTree(customerSegment, state.include);
    if (customerCountLoading) return;
    dispatch(getCustomerCount(customerSegmentQueryTree));
  }

  const renderCountOrError = () => {
    if(!nextStepValid) return null;
    if (!customerCountLoading && customerCountError) {
      return (
        <Grid item xs={12}>
          Try Again!
        </Grid>
      )
    }   
    if (!customerCountLoading && customerCount !== null) {
      return (
        <Grid item xs={12}>
          {customerCount} customers
        </Grid>
      )
    }      
  }

  const checkMissingValue = (stateAttributes) => {
    stateAttributes.forEach((item,index) => {
      if(!item.attribute && !item.operator && !item.value) return
      const productSegementData = step3Data.find(nestedItem => item.attribute === nestedItem.displayName)
      const operatorData = productSegementData.operatorsAndValues.find(nestedItem => item.operator === nestedItem.displayName)
      if (Array.isArray(item.value)) {
          item.value.forEach((nestedItem) => {
              const obj = operatorData.values.valueList.find(doubleNestedItem => nestedItem === doubleNestedItem.displayName)
              if(obj) return 
                  nextStepSetters.attributes(prevState => {
                    const newAttributes = [...prevState] 
                    const attributeObj = {...newAttributes[index]}
                    attributeObj.value = []
                    newAttributes[index] = {...attributeObj}
                    return newAttributes
                  }) 
                  dispatch(setStep3MissingValue(MISSING_VALUE_MESSAGE))
          })
      } else {
        const obj = operatorData.values.valueList.find(nestedItem => item.value === nestedItem.displayName)
        if(obj) return
          nextStepSetters.attributes(prevState => {
            const newAttributes = [...prevState] 
            const attributeObj = {...newAttributes[index]}
            attributeObj.value = ''
            newAttributes[index] = {...attributeObj}
            return newAttributes
          })
        dispatch(setStep3MissingValue(MISSING_VALUE_MESSAGE))
      }
    })
  }

  // logic to remove value of an attribute if it does not exists
  useEffect(()=>{
    const { attributes } = nextStepState;
    if(Object.keys(attributes[0]).length === 0) return
    checkMissingValue(attributes)
  },[])

  // if value are missing, nudge will be shown
  useEffect(()=>{
    isRemovedValue && dispatch(showNudge({ message, type: SEVEARITY_CONTS.error }))
    // clear the redux storage( createCampaign ) for missing value while unmounting
    return () => {
      dispatch(resetStep2MissingValue())
    }
  },[])

  // logic to enable and disable next button
  useEffect(()=>{
    const isNextEnabled = state.include.attributes.reduce(nextStepValidtor,true)
    dispatch(isValidForNext(isNextEnabled))
  },[state])

  // For V1
  // const extraRender = <Grid item xs={2}>
  //   <Button className={styles.btn} variant="contained">Show Count</Button>
  //   <Typography className={styles.btnSub}>* Subject to change as Offer is not live yet</Typography>
  // </Grid>
  
  return (
    <Paper heading="Step 2 -  Fill Customer Details">
      <Grid container className={styles.customerToTargetContainer} justifyContent="space-between" alignItems="baseline">
        <Grid container item xs={12}>
          <Typography className={styles.heading}>Select Customer Target Group <span className={styles.imp}>*</span></Typography>
        </Grid>
        <Grid item xs={12}>
          <LogicalChooser data={data} optionHeader={optionHeader} operatorSub={includeSub} parentState={state.include} updateParentState={setters.include} />
        </Grid>
        {/* For V1 */}
        {/* <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                control={<Checkbox checked={state.isExclude} onChange={(e) => {
                  setters.isExclude(e.target.checked)
                }} />}
                label="Exclude Business Users "
                labelPlacement="end"
              />
            </FormGroup>
          </FormControl>
        </Grid> */}
        {state.isExclude && <Grid item xs={12}>
          <LogicalChooser data={data} optionHeader={optionHeader} operatorSub={excludeSub} parentState={state.exclude} updateParentState={setters.exclude} />
        </Grid>}
        <Grid container className={styles.summaryContainer} item xs={12} sx={{ m: "32px 0px 15px"}}>
          <Grid item xs={12}>
            <Typography className={styles.summaryHeading}>Customer Segment Summary</Typography>
          </Grid>
          <Grid container item xs={12} className={styles.summary} justifyContent="space-between">
            <Grid container item xs={8}>
              <Grid item xs={12} whiteSpace="normal">
                {writeSummary(state.include)}
              </Grid>
              <Grid item xs={12} whiteSpace="normal">{state.isExclude && <>
                <span className={styles.summaryOperators}>Exclude </span>
                {writeSummary(state.exclude)}</>}</Grid>
            </Grid>
            {/* For V1 */}
            <Grid container item xs={2} textAlign="center">
              {renderCountOrError()}
              <Grid item xs={12} marginTop={'10px'}>
                <Button disabled={!nextStepValid} onClick={fetchCustomerCount} className={styles.button} variant='contained'>{customerCountLoading ? 'Loading..' : 'Get Count'}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default CustomerToTarget
